export default __webpack_public_path__ + "static/media/Work_Day_Scheduler.d1b5df73.png";